import { DateTime } from "luxon"

export const DATE_FILTER_FORMAT = "yyyy-MM-dd HH:mm"
const API_DATETIME_FORMAT = "yyyy-MM-dd HH:mm"

export function parseDateTimeFromApi(value: string, locale?: string, zone?: string) {
    const localeToUse = locale ?? "da-DK" // default to DK
    const zoneToUse = zone ?? "Europe/Copenhagen" // database defaults to Cph zone

    // First we try the default API format
    let result = DateTime.fromSQL(value, { locale: localeToUse, zone: zoneToUse })
    if (!result.isValid) {
        // Fall back to ISO format
        result = DateTime.fromISO(value)
    }

    return result
}

export function parseDateFromFilter(value: string, locale?: string) {
    const localeToUse = locale ?? "da-DK" // default to DK
    return DateTime.fromFormat(value, DATE_FILTER_FORMAT)
}

export function formatDateTimeToApi(value: DateTime) {
    return value.toFormat(API_DATETIME_FORMAT)
}

export function formatDateForFilter(value: DateTime) {
    return value.toFormat(DATE_FILTER_FORMAT)
}

export function formatPeriod(start?: DateTime, end?: DateTime) {
    if (!start || !end) return ""

    if (start.hasSame(end, "day")) {
        return `${start.toFormat("yyyy-MM-dd")} ${start.toFormat("HH:mm")} - ${end.toFormat("HH:mm")}`
    } else {
        return `${start.toFormat("yyyy-MM-dd HH:mm")} - ${end.toFormat("yyyy-MM-dd HH:mm")}`
    }
}
